import { Link } from "react-router-dom";
import AmpleHireImageTag from "../ample-hire-html-tags/ample-hire-image-tag";

const TopTapButtonIcon = ({
  iconSrc = "",
  altText = "",
  iconClassName = "",
  onClick = () => {},
  linkText = "",
  active = false,
}) => {
  return (
    <li className={active ? "active" : ""} onClick={onClick}>
      <Link to="">
        <i>
          <AmpleHireImageTag
            className={
              active
                ? `${iconClassName} whiteColorFilter`
                : `${iconClassName} blackColorFilter`
            }
            imgSrc={iconSrc}
            altText={altText}
          />
        </i>
        {linkText}
      </Link>
    </li>
  );
};

export default TopTapButtonIcon;
